import React, { useState, useEffect, useContext } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import { TaskContext } from "../components/TaskContext";
import { UserDataContext } from "../components/UserDataContext";
import { apiRequest } from "../components/Config";

const ChangeView = ({ center, zoom }) => {
  const map = useMap();
  map.setView(center, zoom);
  return null;
};

const MapComponent = () => {
  const [position, setPosition] = useState([50.2555, 19.0241]);
  const [address, setAddress] = useState("");
  const [zoom, setZoom] = useState(15);
  const { userData } = useContext(UserDataContext);
  const iconMarkup = renderToStaticMarkup(
    <i className=" fa fa-map-marker-alt fa-3x" />
  );
  const customMarkerIcon = divIcon({
    html: iconMarkup,
  });
  const { taskId } = useContext(TaskContext);
  const cleanAddress = (address) => {
    return address.replace(/ul\.\s*/gi, ""); // Usuwa "ul."
  };

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest(`location/${taskId}`, "GET");
          if (response && response[0] && response[0].location) {
            const rawAddress = response[0].location;
            const cleanedAddress = cleanAddress(rawAddress);
            setAddress(cleanedAddress);
          } else {
            console.error("Brak danych o lokalizacji w odpowiedzi");
          }
        } catch (error) {
          //setError(error.message);
          console.error(error);
        }
      };
      fetchData();
    }
  }, [taskId, userData]);

  useEffect(() => {
    if (address) {
      handleSearch();
    }
  }, [address]);

  const handleSearch = async () => {
    if (!address) return;

    try {
      /*
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          address
        )}`,
        {
          headers: {
            "User-Agent": "YourAppName/1.0 (your@email.com)",
          },
        }
      );
*/

      const response = await fetch(
        `https://us1.locationiq.com/v1/search.php?key=pk.8a583c461fefef560470621b67dca874&q=${encodeURIComponent(
          address
        )}&format=json`
      );

      if (!response.ok) {
        throw new Error(`Błąd HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (data.length > 0) {
        const { lat, lon } = data[0];
        setPosition([parseFloat(lat), parseFloat(lon)]);
        setZoom(15);
      } else {
        alert("Nie znaleziono lokalizacji!");
      }
    } catch (error) {
      console.error("Błąd geokodowania:", error);
      alert(`Wystąpił błąd podczas wyszukiwania: ${error.message}`);
    }
  };

  return (
    <div>
      <h2>{address}</h2>
      <MapContainer
        center={position}
        zoom={zoom}
        style={{ height: "500px", width: "100%" }}
      >
        <ChangeView center={position} zoom={zoom} />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={position} icon={customMarkerIcon} />
      </MapContainer>
    </div>
  );
};

export default MapComponent;
